import { mergeProps as _mergeProps, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue";
export default {
  name: 'CactusIcon',
  props: {
    size: {
      type: [Number, String],
      default: 24
    }
  },
  render() {
    const size = this.$props.size + 'px';
    const attrs = this.$data.attrs || {};
    const allAttrs = {
      width: attrs.width || size,
      height: attrs.height || size
    };
    return _createVNode("svg", _mergeProps({
      "xmlns": "http://www.w3.org/2000/svg",
      "class": "icon-tabler icon-tabler-cactus",
      "width": "24",
      "height": "24",
      "viewBox": "0 0 24 24",
      "stroke-width": "2",
      "stroke": "currentColor",
      "fill": "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, allAttrs), [_createTextVNode("   "), _createVNode("path", {
      "stroke": "none",
      "d": "M0 0h24v24H0z",
      "fill": "none"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M6 9v1a3 3 0 0 0 3 3h1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M18 8v5a3 3 0 0 1 -3 3h-1"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M10 21v-16a2 2 0 1 1 4 0v16"
    }, null), _createTextVNode("   "), _createVNode("path", {
      "d": "M7 21h10"
    }, null), _createTextVNode(" ")]);
  }
};